import { useQuery } from "react-query";
import { getOfficeType } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useGetActiveOfficeType = () => {
  return useQuery("OfficeType", getOfficeType, {
    refetchOnWindowFocus: false,
  });
};
